import { campaignApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

const campaignSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const CAMPAIGNS_ACTION_TYPE = createNamedActions('campaigns', {
  GET_CAMPAIGNS: 'GET_CAMPAIGNS',
  GET_CAMPAIGN: 'GET_CAMPAIGN',
  SAVE_CAMPAIGN: 'SAVE_CAMPAIGN',
  GET_CAMPAIGN_AUDIENCE: 'GET_CAMPAIGN_AUDIENCE',
  ACTIVATE_CAMPAIGN: 'ACTIVATE_CAMPAIGN',
  GET_CAMPAIGN_ENROLLMENTS: 'GET_CAMPAIGN_ENROLLMENTS',
});

export const getCampaignsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await campaignApi.getCampaigns();

  return dispatch({
    type: CAMPAIGNS_ACTION_TYPE.GET_CAMPAIGNS,
    payload: normalize(data, [campaignSchema]).entities.data,
  });
});

export const getCampaignAction = catchAsyncActionError(({ campaignId }) => async dispatch => {
  const { data } = await campaignApi.getCampaignById({ campaignId });

  return dispatch({
    type: CAMPAIGNS_ACTION_TYPE.GET_CAMPAIGN,
    payload: data,
  });
});

// Save authors the campaign's real steps (DEV-4400 / T6). Create POSTs the SaveCampaignRequest → 201;
// update PUTs it → 200. Both resolve to the CampaignModel (incl. compiledLoanActionId), which the caller
// reads off the dispatched action's payload to route to the saved campaign.
export const createCampaignAction = catchAsyncActionError(({ request }) => async dispatch => {
  const { data } = await campaignApi.createCampaign(request);

  return dispatch({
    type: CAMPAIGNS_ACTION_TYPE.SAVE_CAMPAIGN,
    payload: data,
  });
});

export const updateCampaignAction = catchAsyncActionError(
  ({ campaignId, request }) =>
    async dispatch => {
      const { data } = await campaignApi.updateCampaign({ campaignId, request });

      return dispatch({
        type: CAMPAIGNS_ACTION_TYPE.SAVE_CAMPAIGN,
        payload: data,
      });
    },
);

export const getCampaignAudienceAction = catchAsyncActionError(
  ({ campaignId }) =>
    async dispatch => {
      const { data } = await campaignApi.getCampaignAudience({ campaignId });

      return dispatch({
        type: CAMPAIGNS_ACTION_TYPE.GET_CAMPAIGN_AUDIENCE,
        payload: data,
      });
    },
);

export const activateCampaignAction = catchAsyncActionError(
  ({ campaignId, enrollExisting }) =>
    async dispatch => {
      const { data } = await campaignApi.activateCampaign({ campaignId, enrollExisting });

      return dispatch({
        type: CAMPAIGNS_ACTION_TYPE.ACTIVATE_CAMPAIGN,
        payload: data,
        meta: { campaignId },
      });
    },
);

export const getCampaignEnrollmentsAction = catchAsyncActionError(
  ({ campaignId }) =>
    async dispatch => {
      const { data } = await campaignApi.getCampaignEnrollments({ campaignId });

      return dispatch({
        type: CAMPAIGNS_ACTION_TYPE.GET_CAMPAIGN_ENROLLMENTS,
        payload: data,
      });
    },
);
